import { POST } from "../../index";
export const getCarAnnualApproveList = (param) => POST("/v1/CarAnnualApprove/getCarAnnualApproveList", param);
export const getCarApproveProgressList = (param) => POST("/v1/CarAnnualApprove/getCarApproveProgressList", param);
export const submitCarAudit = (param) => POST("/v1/CarAnnualApprove/submitCarAudit", param);

